'use client'

import { subscribeBlogAPI } from '@/api-config/post';
import Link from 'next/link';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

const NewsLetter = ({ context, bgcolor }) => {
    const [loader, setLoader] = useState(false);
    const [email, setEmail] = useState(''); // Initialize with an empty string
    const dispatch = useDispatch();

    const handleSuccess = () => {
        setLoader(false);
        setEmail(''); // Reset email to an empty string
    };

    const handleSubmit = () => {
        setLoader(true);
        dispatch(subscribeBlogAPI({ email }, setLoader, handleSuccess));
    };

    return (
        <section className='px-4'>
            <div className={`relative z-10 flex-col  items-center justify-center w-full px-4 xl:px-0 mx-auto ${bgcolor ? "bg-[#F3E1DD]" : "bg-white"} bg-opacity-50 mb-8 last:mb-0 rounded-xl max-w-7xl`}>
                <div className="flex flex-col items-center justify-center w-full p-6 text-center rounded-xl py-14">
                    <h2 className="font-bold md:text-3xl text-6xl w-full mb-4 max-w-2xl mx-auto">
                        {context?.stay}
                    </h2>
                    <p className="text-2xl md:text-lg md:mb-8 mb-10 w-full max-w-2xl mx-auto">
                        {context?.subscribe}
                    </p>
                    <div className="w-full newsletter-form">
                        <div>
                            <div className="flex flex-wrap items-center justify-center gap-4">
                                <div className="flex-grow max-w-md">
                                    <label htmlFor="email" className="sr-only">
                                        {context?.EmailAddress}
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="data[email]"
                                        placeholder={context?.EmailAddress}
                                        required
                                        className="w-full px-4 py-3 border rounded-lg text-gray-700"
                                        value={email}
                                        onChange={e => setEmail(e?.target?.value)}
                                    />
                                </div>
                                <button
                                    onClick={handleSubmit}
                                    disabled={loader}
                                    className="px-8 py-3 bg-[#eb532e] text-white rounded-lg text-lg font-semibold hover:bg-[#eb532e]"
                                >
                                    {loader ? context?.pleasewait : context?.notify}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className=" text-sm w-full text-center mt-12">
                        {context?.wecare}{' '}
                        <Link
                            href="/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            className=""
                        >
                            {context?.PrivacyPolicy}
                        </Link>
                        .
                    </div>
                </div>
            </div>
        </section>
    );
};

export default NewsLetter;
